import styled from 'styled-components'

import { helpers } from 'styles'

import { ButtonIcon } from 'components/Buttons'

type Props = {
	colorScheme: 'dark' | 'light'
}

export const ButtonCopy = styled(ButtonIcon)<Props>`
	position: absolute;
	top: 11px;
	right: 11px;
	color: ${({ colorScheme }) => (colorScheme === 'dark' ? helpers.color.secondary : helpers.color.textMuted)};
	width: 26px;
	height: 26px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s, opacity 0.2s;
	opacity: 0.4;

	&:is(:focus-visible, :hover) {
		color: ${({ colorScheme }) => (colorScheme === 'dark' ? helpers.color.secondary : helpers.color.primary)};
		background-color: ${({ colorScheme }) => (colorScheme === 'dark' ? helpers.color.primary : helpers.color.primaryTranslucent)};
		opacity: 1;
	}
`
